import { useEffect } from "react";

import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";

import * as Dialog from "@/components/dialog/DialogLayout";
import { useStore } from "@/store";
import { twMerge } from "@/utils/twMerge";
import { useFeatureFlag } from "@/utils/useFeatureFlag";

import { TeamDialogContent } from "./TeamDialogContent";
import { TeamDialogSidebar } from "./TeamDialogSidebar";
import { useOpenTeamDialogFromQuery } from "./useOpenTeamDialogFromQuery";

export const TeamDialog = observer(function TeamDialog() {
  const { dialog } = useStore();
  const { isOpen, team } = dialog.teamDialog;
  const isBillingEnabled = Boolean(useFeatureFlag("team-billing"));
  useOpenTeamDialogFromQuery();

  useEffect(() => {
    dialog.teamDialog.setBillingEnabled(isBillingEnabled);
  }, [dialog.teamDialog, isBillingEnabled]);

  const handleClose = () => {
    runInAction(() => {
      dialog.teamDialog.close();
    });
  };

  return (
    <Dialog.Root open={isOpen} onClose={handleClose} aria-label={team?.title}>
      <Dialog.Backdrop />
      <Dialog.Container>
        <Dialog.Panel
          className={twMerge(
            "flex-row gap-2.5 max-w-[864px] max-h-[640px] w-full h-full p-2.5",
            "sm:flex-col sm:max-w-none sm:max-h-none sm:rounded-none",
          )}
        >
          <TeamDialogSidebar />
          <TeamDialogContent />
          <Dialog.CloseButton className="top-3.5 right-3.5 w-[30px] h-[30px] rounded-8 hover:bg-blue-200 dark:hover:bg-blue-800">
            <Dialog.CloseIcon />
          </Dialog.CloseButton>
        </Dialog.Panel>
      </Dialog.Container>
    </Dialog.Root>
  );
});
